<img src="http://ionprod:8001/oligoGlyphs/v1/glyphs/size-png?width=400&height=60&isisno={{isisno}}">